import { categories as propertyCategories } from '@luxuryescapes/lib-global';

import { AccommodationPropertiesSearchInput } from '~/components/Accommodation/Pages/Properties/components/AccommodationPropertiesSearchForm';

import { InternalService } from '~/services/AccommodationService';

import {
  PROMOTIONS_FILTER_OPTIONS,
  RATES_ENABLED_FILTER_OPTIONS,
  SUPPLIER_STATE_FILTER_OPTIONS,
  normalizeIndicativePropertyStateFilters,
} from './indicativePropertyStateFilters';

export function getSearchInputFromSearchParams(searchParams: URLSearchParams): AccommodationPropertiesSearchInput {
  const input: AccommodationPropertiesSearchInput = {};
  const propertyName = searchParams.get('propertyName');
  if (propertyName) {
    input.propertyName = propertyName;
  }
  const id = searchParams.get('id');
  if (id) {
    input.id = id;
  }
  const city = searchParams.get('city');
  if (city) {
    input.city = city;
  }
  const country = searchParams.get('country');
  if (country) {
    input.country = country;
  }
  const rating = searchParams.get('rating');
  if (rating) {
    input.rating = rating;
  }
  const categories = searchParams.get('categories');
  if (categories) {
    input.categories = categories.split(',') as Array<propertyCategories.CategoryName>;
  }
  const chainNames = searchParams.get('chainNames');
  const excludedChainNames = searchParams.get('excludedChainNames');
  if (chainNames) {
    input.chainNames = chainNames
      .split(',')
      .map((value) => value.trim())
      .filter(Boolean);
    input.chainFilterMode = 'include';
  } else if (excludedChainNames) {
    input.chainNames = excludedChainNames
      .split(',')
      .map((value) => value.trim())
      .filter(Boolean);
    input.chainFilterMode = 'exclude';
  }
  const internalService = searchParams.get('internalService');
  if (internalService) {
    input.internalService = internalService as InternalService;
  }
  const ratesEnabledFilters = normalizeIndicativePropertyStateFilters(
    searchParams.get('ratesEnabledFilters') ?? '',
    RATES_ENABLED_FILTER_OPTIONS,
  );
  if (ratesEnabledFilters) {
    input.ratesEnabledFilters = ratesEnabledFilters;
  }
  const supplierStateFilters = searchParams.get('supplierStateFilters');
  if (supplierStateFilters) {
    const parsed = normalizeIndicativePropertyStateFilters(supplierStateFilters, SUPPLIER_STATE_FILTER_OPTIONS);
    if (parsed) {
      input.supplierStateFilters = parsed;
    }
  }
  const promotionsFilters = searchParams.get('promotionsFilters');
  if (promotionsFilters) {
    const parsed = normalizeIndicativePropertyStateFilters(promotionsFilters, PROMOTIONS_FILTER_OPTIONS);
    if (parsed) {
      input.promotionsFilters = parsed;
    }
  }
  return input;
}
